// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wx yf","wrapperNeonRental":"wy x6"};